// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wx7s","icon":"styles_icon__2m-Rx"};